// Add a new object for every post you publish.
// Only update THIS file and every place that lists posts will update automatically.
const blogPosts = [
  {
    slug: 'why-image-compression-matters',
    title: 'Why Image Compression Matters: Boost Website Speed, SEO & User Experience',
    date: '2025-07-14',
    author: 'Dev Team',
    excerpt:
      'Learn why compressing images is crucial for faster websites, better SEO, and improved user experience.',
  },
  {
    slug: 'best-image-formats',
    title: 'Best Image Formats for the Web: JPEG, PNG, WebP & More',
    date: '2025-07-13',
    author: 'Dev Team',
    excerpt:
      'Discover which image formats offer the best mix of quality, size, and browser support for modern sites.',
  },
  {
    slug: 'jpeg-vs-png',
    title: 'JPEG vs PNG — Which Image Format Should You Use?',
    date: '2025-07-12',
    author: 'Dev Team',
    excerpt:
      'Unsure whether to choose JPEG or PNG? Compare pros, cons, and ideal use‑cases for each format.',
  },
];

export default blogPosts;
